import { CommonModule } from '@angular/common';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import * as i0 from "@angular/core";
export class InfoFieldSelectorModalModule {
}
InfoFieldSelectorModalModule.ɵfac = function InfoFieldSelectorModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InfoFieldSelectorModalModule)(); };
InfoFieldSelectorModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: InfoFieldSelectorModalModule });
InfoFieldSelectorModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule,
        CommonModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        FeatureNeededModule] });
